type GenericCardProps = Omit<React.SVGProps<SVGSVGElement>, 'width' | 'height'> & {
  size: number;
};

export const GenericCard = ({ size, ...props }: GenericCardProps) => {
  const height = Math.round(size * 0.625); // Credit card aspect ratio

  return (
    <svg
      {...props}
      width={size}
      height={height}
      viewBox="0 0 80 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="80" height="50" rx="4" fill="white" stroke="#d1d5db" />
      <rect x="8" y="8" width="64" height="6" rx="2" fill="#9ca3af" />
      <rect x="8" y="20" width="32" height="4" rx="1" fill="#d1d5db" />
      <rect x="8" y="26" width="24" height="4" rx="1" fill="#d1d5db" />
      <rect x="8" y="32" width="20" height="4" rx="1" fill="#d1d5db" />
      <rect x="52" y="20" width="20" height="4" rx="1" fill="#d1d5db" />
    </svg>
  );
};
